import React from 'react'

import Index from './components'
import ChatContextProvider from './context'

const Chat = () => {
    return (
        <ChatContextProvider>
            <Index />
        </ChatContextProvider>
    )
}

export default Chat
